module.exports = __webpack_public_path__ + "static/media/babyspinach.bdc98c2f.webp";